import { GetCarUseResultInput } from '../../../API';
import { GetCarUseResultQuery, QueryOutputType } from '../../../common/type/QueryType';
import { graphqlOperationWithTokenRefresh } from '../../../common/api/graphqlOperation';

/**
 * 車両利用実績一覧取得用のクエリ
 */
const query = /* GraphQL */ `
	query GetCarUseResult($offsegInput: GetCarUseResultInput!, $g500LiteInput: GetCarUseResultInput!) {
		getOffsegCarUseResult(input: $offsegInput) {
			responseType
			message
			carUseResults {
				numberPlate
				organizationId
				carId
				driverId
				startDatetime
				endDatetime
			}
		}
		getG500LiteCarUseResult(input: $g500LiteInput) {
			responseType
			message
			carUseResults {
				numberPlate
				organizationId
				carId
				driverId
				startDatetime
				endDatetime
			}
		}
	}
`;

/**
 * 車両利用実績一覧取得APIを呼び出す
 */
export const queryGetCarUseResult = async (
	offsegInput: GetCarUseResultInput,
	g500LiteInput: GetCarUseResultInput,
	authorizationToken: string,
): Promise<QueryOutputType<GetCarUseResultQuery>> => {
	const apiResponse = await graphqlOperationWithTokenRefresh<GetCarUseResultQuery>(
		query,
		{ offsegInput: offsegInput, g500LiteInput: g500LiteInput },
		authorizationToken,
	);
	console.log(apiResponse);

	return apiResponse;
};
